export const SECTION_SYSTEM_GENERAL = {
  name: "General",
  path: "#general",
}
export const SECTION_SYSTEM_SOFTWARE = {
  name: "Software",
  path: "#software",
}
export const SECTION_SYSTEM_MODEM = {
  name: "Modem",
  path: "#modem",
}
export const SECTION_SYSTEM_VOLTAGES = {
  name: "Parental Board Voltages",
  path: "#parental-board-voltages",
}
export const SECTION_SYSTEM_PWB_METRICS = {
  name: "Power Board Metrics",
  path: "#power-board-metrics",
}
export const SECTION_SYSTEM_TBB_METRICS = {
  name: "Transceiver Board Metrics",
  path: "#transceiver-board-metrics",
}
export const SECTION_SYSTEM_BUC_METRICS = {
  name: "BUC Metrics",
  path: "#buc-metrics",
}
export const SECTION_SYSTEM_LNB_METRICS = {
  name: "LNB Metrics",
  path: "#lnb-metrics",
}

export const SECTION_OVERVIEW_SATELLITE_SIGNAL = {
  name: "Satellite signal",
  path: "#satellite-signal",
}

export const SECTION_OVERVIEW_VEHICLE_ORIENTATION = {
  name: "Vehicle orientation",
  path: "#vehicle-orientation",
}

export const SECTION_OVERVIEW_SYSTEM_MESSAGES = {
  name: "System messages",
  path: "#system-messages",
}

export const SECTION_OVERVIEW_POSITION = {
  name: "Position",
  path: "#position",
}

export const SECTION_OVERVIEW_WIFI = {
  name: "Wifi",
  path: "#wifi",
}

export const SECTION_OVERVIEW_TEMPERATURES = {
  name: "Temperatures",
  path: "#temperatures",
}

export const SECTION_OVERVIEW_FANS = {
  name: "Fans",
  path: "#fans",
}

export const SECTION_OVERVIEW_TRANSMISSION = {
  name: "Transmission",
  path: "#transmission",
}

export const pages = {
  overview: {
    name: "Overview",
    path: "/",
    sections: [
      SECTION_OVERVIEW_SATELLITE_SIGNAL,
      SECTION_OVERVIEW_POSITION,
      SECTION_OVERVIEW_WIFI,
      SECTION_OVERVIEW_TRANSMISSION,
      SECTION_OVERVIEW_SYSTEM_MESSAGES,
      SECTION_OVERVIEW_TEMPERATURES,
      SECTION_OVERVIEW_FANS,
    ],
  },
  signal: {
    name: "Signal",
    path: "/signal",
    sections: [SECTION_OVERVIEW_SATELLITE_SIGNAL],
  },
  system: {
    name: "System",
    path: "/system",
    sections: [
      SECTION_SYSTEM_GENERAL,
      SECTION_SYSTEM_SOFTWARE,
      SECTION_SYSTEM_MODEM,
      SECTION_SYSTEM_VOLTAGES,
      SECTION_SYSTEM_PWB_METRICS,
      SECTION_SYSTEM_TBB_METRICS,
      SECTION_SYSTEM_BUC_METRICS,
      SECTION_SYSTEM_LNB_METRICS,
    ],
  },
  support: {
    name: "Support",
    path: "/support",
    sections: [
      {
        name: "Contact",
        path: "#contact",
      },
      {
        name: "Guides and manuals",
        path: "#guides-and-manuals",
      },
      // TODO unhide after mvp
      // {
      //   name: "Error code index",
      //   path: "#error-codes",
      // },
    ],
  },
} as const
